var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.532 7.37366C11.5029 7.07866 11.3839 6.79974 11.1909 6.57475L6.02187 0.545732C5.90181 0.394624 5.75252 0.269275 5.58292 0.177177C5.41332 0.0850801 5.22689 0.0281248 5.03477 0.00971794C4.84266 -0.00868893 4.64881 0.0118294 4.4648 0.0700464C4.2808 0.128263 4.11042 0.222983 3.96386 0.348545C3.8173 0.474108 3.69755 0.627933 3.61179 0.800825C3.52603 0.973717 3.47601 1.16213 3.46472 1.35479C3.45343 1.54745 3.48111 1.74041 3.54609 1.92214C3.61108 2.10386 3.71203 2.27062 3.84293 2.41244L8.21191 7.5081L3.84182 12.6038C3.71298 12.746 3.61397 12.9126 3.55063 13.0937C3.48728 13.2749 3.4609 13.4669 3.47304 13.6584C3.48518 13.8499 3.5356 14.0371 3.62131 14.2088C3.70701 14.3805 3.82627 14.5332 3.97204 14.658C4.1178 14.7828 4.28711 14.8772 4.46995 14.9354C4.6528 14.9937 4.84547 15.0147 5.03657 14.9972C5.22767 14.9797 5.41332 14.9241 5.58256 14.8336C5.75179 14.7432 5.90117 14.6197 6.02187 14.4705L11.1909 8.44146C11.316 8.29518 11.4106 8.12537 11.4692 7.94199C11.5278 7.75862 11.5491 7.56539 11.532 7.37366Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d015d9ed89353969bcf9825611c877a4.svg";
export { ForwardRef as ReactComponent };